var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_54216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59525 5.31822C1.60908 8.41997 2.22025 11.7149 2.22025 21.7247C2.22025 30.0372 0.769912 38.3703 8.36041 40.3321C10.7307 40.9416 31.732 40.9416 34.0991 40.3289C37.2594 39.5135 39.8307 36.9501 40.1822 32.4803C40.2313 31.8565 40.2313 11.6041 40.1807 10.9676C39.807 6.20647 36.8762 3.46255 33.0145 2.9068C32.1294 2.77855 31.9521 2.74055 27.4111 2.73264C11.3038 2.74055 7.773 2.0233 4.59525 5.31822Z",
    fill: "url(#paint0_linear_1422_54216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2179 7.69665C15.4688 7.69665 10.0095 7.18523 7.92423 12.5369C7.06289 14.7472 7.18798 17.6178 7.18798 21.7281C7.18798 25.335 7.07239 28.7249 7.92423 30.9178C10.0047 36.2726 15.5084 35.7596 21.2147 35.7596C26.72 35.7596 32.3962 36.3328 34.5068 30.9178C35.3697 28.6853 35.2431 25.8575 35.2431 21.7281C35.2431 16.2466 35.5455 12.7079 32.8871 10.0511C30.1954 7.3594 26.5553 7.69665 21.2116 7.69665H21.2179ZM19.9607 10.2252C31.9529 10.2062 33.4792 8.87307 32.6369 27.3933C32.3376 33.9436 27.3501 33.2247 21.2195 33.2247C10.0411 33.2247 9.71973 32.9049 9.71973 21.7218C9.71973 10.4089 10.6064 10.2316 19.9607 10.2221V10.2252ZM28.7071 12.5543C27.7776 12.5543 27.024 13.308 27.024 14.2374C27.024 15.1668 27.7776 15.9205 28.7071 15.9205C29.6365 15.9205 30.3901 15.1668 30.3901 14.2374C30.3901 13.308 29.6365 12.5543 28.7071 12.5543ZM21.2179 14.5224C17.239 14.5224 14.0137 17.7492 14.0137 21.7281C14.0137 25.7071 17.239 28.9323 21.2179 28.9323C25.1968 28.9323 28.4205 25.7071 28.4205 21.7281C28.4205 17.7492 25.1968 14.5224 21.2179 14.5224ZM21.2179 17.051C27.4008 17.051 27.4087 26.4053 21.2179 26.4053C15.0366 26.4053 15.0271 17.051 21.2179 17.051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1422_54216",
    x1: 4.66811,
    y1: 38.3055,
    x2: 39.9851,
    y2: 7.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_54216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(2.2207 2.73047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.422a6fbce6ec8efbdbe73c2f54a9e45a.svg";
export { ForwardRef as ReactComponent };